document.getElementById('calculate').addEventListener('click', function() {
    var volume = parseFloat(document.getElementById('volume').value);
    var strength = parseFloat(document.getElementById('strength').value);
    var finalStrength = parseFloat(document.getElementById('final-strength').value);

    if (isNaN(volume) || isNaN(strength) || isNaN(finalStrength)) {
        document.getElementById('result').innerHTML = 'Please select your vape juice volume, nicotine shot strength, and desired total nicotine strength.';
    } else {
        var result = calculateNicShot(volume, strength, finalStrength);
        var resultText = `To get <b>${finalStrength}mg</b> in your <b>${volume}ml</b> vape juice, the amount of <b>${strength}mg</b> nicotine shot you need is <b>${result}ml</b>`;
        document.getElementById('result').innerHTML = resultText;
    }
});

function calculateNicShot(volume, strength, finalStrength) {
    if (volume === 50 && strength === 18 && finalStrength === 3) {
        return 10;
    } else if (volume === 50 && strength === 18 && finalStrength === 6) {
        return 25;
    } else if (volume === 50 && strength === 20 && finalStrength === 3) {
        return 8.8;
    } else if (volume === 50 && strength === 20 && finalStrength === 6) {
        return 21.4;
    } else if (volume === 100 && strength === 18 && finalStrength === 3) {
        return 20;
    } else if (volume === 100 && strength === 18 && finalStrength === 6) {
        return 50;
    } else if (volume === 100 && strength === 20 && finalStrength === 3) {
        return 17.6;
    } else if (volume === 100 && strength === 20 && finalStrength === 6) {
        return 42.9;
    } else {
        return "Invalid input";
    }
}

function inputValue(inputId, value) {
    var inputField = document.getElementById(inputId);
    var label = inputField.previousElementSibling;
    inputField.value = value;
    label.classList.add('visible');
    inputField.style.marginTop = '20px';
}
